module.exports = __webpack_public_path__ + "img/brandstory_info02.85c51cdb.png";